function open () {
  window.open("https://p.qiao.baidu.com/cps/chat?siteId=18486683&userId=22110451&siteToken=e24e555088a6849b206466783827b1a0","_blank");
}
export default {
  open
};



// WEBPACK FOOTER //
// ./src/util/consulting.js